import React, { useState } from 'react';
import { toast } from 'sonner';
import { adminAPI } from '../../lib/adminAPI';

export const LEAD_STATUSES = [
  { value: 'new', label: 'New' },
  { value: 'contacted', label: 'Contacted' },
  { value: 'closed', label: 'Closed' },
];

export const normalizeStatus = (status) => (LEAD_STATUSES.some(s => s.value === status) ? status : 'new');

// Inline status selector styled as a coloured pill. Persists on change.
export const LeadStatusSelect = ({ contactId, status, onChange, size = 'sm' }) => {
  const [saving, setSaving] = useState(false);
  const current = normalizeStatus(status);

  const handleChange = async (e) => {
    const next = e.target.value;
    if (next === current) return;
    setSaving(true);
    try {
      await adminAPI.updateContactStatus(contactId, next);
      onChange?.(contactId, next);
      toast.success(`Marked as ${LEAD_STATUSES.find(s => s.value === next).label}`);
    } catch (error) {
      toast.error('Could not update status', { description: error.response?.data?.detail || 'Please try again.' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <select
      value={current}
      onChange={handleChange}
      onClick={(e) => e.stopPropagation()}
      disabled={saving}
      className={`lead-status-select lead-status-${current} lead-status-${size}`}
      aria-label="Lead status"
      data-testid={`lead-status-select-${contactId}`}
    >
      {LEAD_STATUSES.map(s => (
        <option key={s.value} value={s.value}>{s.label}</option>
      ))}
    </select>
  );
};
